interface TertiaryMarveriButtonProps {
  icon: string;
  label: string;
  labelStyle?: string;
  onClick: () => void;
}

export const TertiaryMarveriButton = ({
  icon,
  label,
  labelStyle,
  onClick,
}: TertiaryMarveriButtonProps) => {
  return (
    <div
      className="group relative cursor-pointer rounded-[4px] border border-N500 p-2 hover:border-N400"
      onClick={onClick}
    >
      <img
        src={icon}
        alt="compare duplicate"
        className="size-[20px] group-hover:filter-hover-filter"
      />
      <div
        className={`${labelStyle} absolute z-[100] hidden rounded-[8px] border border-[#D9D9D9] bg-white p-1 text-[12px] font-medium text-black group-hover:block`}
      >
        {label}
      </div>
    </div>
  );
};
